const VAULTGRID_STICKER_PACK_V2_FILES = [
  "01_main_finger_guns",
  "02_dorian_confused_travolta",
  "03_female_thinker",
  "04_female_bus_stop",
  "05_main_thoughtful_head",
  "06_dorian_rainy_window",
  "07_female_pixel_sunglasses",
  "08_dorian_deep_drag",
  "09_female_excellent",
  "10_main_like",
  "11_dorian_dislike",
  "12_female_heart",
  "13_main_fire",
  "14_dorian_ok",
];

export const CHAT_STICKERS = VAULTGRID_STICKER_PACK_V2_FILES.map((fileName) => ({
  id: `vg-v2-${fileName.slice(0, 2)}`,
  src: `/assets/chat/stickers/v2/${fileName}.webp`,
}));

const CHAT_STICKER_BY_ID = new Map(CHAT_STICKERS.map((sticker) => [sticker.id, sticker]));

export function getChatSticker(stickerId) {
  return CHAT_STICKER_BY_ID.get(String(stickerId || "").trim()) || null;
}

export function getChatStickerFromPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (String(payload.kind || "").trim().toLowerCase() !== "sticker") return null;
  return getChatSticker(payload.sticker_id);
}
